
import httpClient from './httpClient';

export default {
  async import_users(company_id) {
    const res = await httpClient({ requiresAuth: true }).get('/kot-employee/'+company_id)

    return res.data
  }
}